import { Box } from "@material-ui/core";
import React from "react";
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';

interface CheckLabelProps {
    value: boolean;
}

export default function CheckLabel(props: CheckLabelProps) {

    const { value } = props;

    return (
        <React.Fragment>
            {value ?
                <Box display="flex" alignItems="center" justifyContent="center">
                    <CheckIcon style={{ backgroundColor: "green", color: "#fff", borderRadius: "50%", fontSize: "15px" }} />
                    <span style={{ paddingLeft: "3px" }}>Sim</span>
                </Box>
                :
                <Box display="flex" alignItems="center" justifyContent="center">
                    <CloseIcon style={{ backgroundColor: "red", color: "#fff", borderRadius: "50%", fontSize: "15px" }} />
                    <span style={{ paddingLeft: "3px" }}>Não</span>
                </Box>
            }
        </React.Fragment>
    )
}
